module.exports = __webpack_public_path__ + "static/media/blue_belt_icon.fb3c928b.svg";